import React, {useContext, useEffect, useState, useCallback, useRef} from 'react'
import SearchResultsContainer from './components/VehicleSearch/SearchResultsContainer'
import {hideHostLoaderWhenReady} from './services/hostLoader';
import {translateService, Translate} from './services/TranslateService';
import moment from 'moment-timezone';
import {ensureLanguage} from "./locales";
import './App.scss';
import {GlobalStore} from './reduxStore';
import {useDispatch, useSelector} from 'react-redux';
import {deferComponent} from './components/Deferred/deferComponent';
import ApiServiceFactory from './services/api/ApiServiceFactory';
import BusyModal from './components/BusyModal/BusyModal';
import ResponseModal from './components/ResponseModal/ResponseModal';
import Modal from 'react-modal';
import {handleUrlWithHashtag, processModelId, resetUrlForPaymentRetry} from './GetUrlParams';
import md5 from 'md5';
import {DataContext} from './contexts/dataContext';
import {nextWorkingDay, isCompanyDataValid} from "./components/MakeReservation/util";
import axios from "axios";
import {Dialog} from "@mui/material";
import {Card} from "react-bootstrap";
import {GetCustomerBehaviourParams} from "./services/CustomerBehaviourData";
import {extractCityFromPlace} from "./services/extractCityFromPlace";
import GoogleMap from "./components/Map/DeferredMap";
import {armStartup, markGeocodeDone, markGeocodeLibrary, markMount, startupKindFor} from "./services/startupTiming";
import {retireServerMapPlaceholder} from "./services/serverPlaceholder";
import {releaseHostReservation} from "./services/startupSearch";
import {loadGoogleLibrary} from "./services/googleMapsLoader";
import {ActiveFilterIndicators} from "./components/VehicleSearch/ActiveFilterIndicators/ActiveFilterIndicators";
import SearchFilter from "./components/VehicleSearch/SearchFilter";
import SearchSummaryBar from "./components/VehicleSearch/SearchSummaryBar";
import {cStylesApp} from './CustomModalStyles';
import {scrollToElementWithOffset, getAndClearUrlStringValue, getAndClearUrlTimeValue} from "./GetUrlParams";
import {parseStartOffset} from "./services/startOffset";
import {MAX_URL_DAYS, parseLengthParam} from "./GetUrlParams";
import {resolveUrlLocation} from "./services/urlLocation";
import { RidSessionData } from "./interfaces/RidSessionData";
import {claritySetSafe, clarityEventSafe} from "./services/clarity/claritySteps";
import {firePendingPurchase, hasPendingPurchase} from "./services/PurchaseGtagEvent";
import {walleyReturnScreen} from "./services/walleyPaymentPoller";
import {normalizeCouponCode} from "./services/couponCode";
// import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'; // TODO: re-enable when BE reCaptcha is ready

declare var google: any;

const LoginContainer = deferComponent(() => import('./components/Login/LoginContainer'));
const MakeReservation = deferComponent(async () => {
    const module = await import('./components/MakeReservation/MakeReservation');
    return {default: module.MakeReservation};
});

const App = (props: any) => {
    const {shortcodeLang, shortcodeCity, shortcodeMap} = props;
    const search = handleUrlWithHashtag();
    const urlLang = new URLSearchParams(search).get('lang') ?? undefined;
    const lang = !urlLang ? shortcodeLang !== undefined ? (shortcodeLang === "en" ? "en" : "fi") : "fi" : urlLang || "fi"; // url lang takes priority
    const {v3ApiUrl, walleyApiUrl, appContext, changeSearchParameters, searchParameters, route, page, changeRoute, changeResType, enableOneWay,
        sendGa4Event, changeCustomerBehaviourData, changeAcrissCodeFromUrl, changeModelId, storedCoupon, rootUrl } = useContext(DataContext);
    const dispatch = useDispatch();
    const responseModal = useSelector((state: GlobalStore) => state.chauffeurReducer.responseModal);
    const apiMessage = useSelector((state: GlobalStore) => state.chauffeurReducer.apiMessage);
    const token = useSelector((state: GlobalStore) => state.chauffeurReducer.dbToken);
    const jwt = useSelector((state: GlobalStore) => state.chauffeurReducer.jwt);
    const API_URL = useSelector((state: GlobalStore) => state.chauffeurReducer.API_URL);
    const [showLogin, setShowLogin] = useState(false);
    const [showFullScreenMap, setShowFullScreenMap] = useState<boolean>(false);
    const [mapFiltersOpen, setMapFiltersOpen] = useState(false);
    const [showPaymentResultScreen, setShowPaymentResultScreen] = useState<string | undefined>(undefined);
    const dataContext = useContext(DataContext);
    const version = import.meta.env.VITE_VERSION;
    const copyrightYear = moment().get('year');
    let startDate = new URLSearchParams(search).get("startdate") ? getAndClearUrlTimeValue('startdate') : null;
    let endDate = new URLSearchParams(search).get("enddate") ? getAndClearUrlTimeValue('enddate') : null
    // vip takes priority over normal discount code; normalised so a link written as
    // ?code=kesa2026 reports identically to one written as ?code=KESA2026
    const urlDiscountRaw = new URLSearchParams(search).get("vip") ?? new URLSearchParams(search).get("code");
    let discount = normalizeCouponCode(urlDiscountRaw) || null;
    let carId = !(sessionStorage.getItem('carIdChanged') ?? undefined) ? new URLSearchParams(search).get("carid") : null;
    let acriss = new URLSearchParams(search).get("acriss")
    let segmentParam = new URLSearchParams(search).get("segment")?.toLowerCase() // ?segment=car|van (campaign deep links)
    let day = new URLSearchParams(search).get("days") ? getAndClearUrlStringValue("days") : null;
    // alternative to startdate/enddate for evergreen links: a duration ("72h", "3d") or
    // weekday name ("monday") instead of a hardcoded date that goes stale on a banner
    let startOffset = new URLSearchParams(search).get("startoffset") ? getAndClearUrlStringValue("startoffset") : null;
    let city = shortcodeCity === undefined ?
        new URLSearchParams(search).get("city") ? getAndClearUrlStringValue('city') || "" : '' : shortcodeCity;
    let modelId = processModelId(new URLSearchParams(search).get("modelid") ?? undefined);
    let mapEnableUrl = shortcodeMap === undefined ? (new URLSearchParams(search).get("map")) || "true" : shortcodeMap;
    let urlCodeSavedData = sessionStorage.getItem('urlCodeValid') ?? undefined;
    let urlLat = new URLSearchParams(search).get("lat");
    let urlLon = new URLSearchParams(search).get("lon");
    let noVat = new URLSearchParams(search).get("noVat");
    const defaultDate = nextWorkingDay().hour(8).minute(60);
    let oneway = sessionStorage.getItem('selectedCar') === null ? new URLSearchParams(search).get("oneway") : null;
    const [latlng, setLatlng] = useState<number[]>([
        60.167488, // default lat
        24.942747,// default lng
        0 // 0 = normal res, 1 = oneway coords
    ]);
    const customerId = new URLSearchParams(search).get("id")
    const authHash= new URLSearchParams(search).get("hash")
    const customerBehaviourData = GetCustomerBehaviourParams();
    // Walley return URL carries only `?r={reservationId}`. Walley redirects when the
    // customer finishes the iframe (failures keep them in it), but that is not proof
    // of payment: BE captures the money after its server-to-server callback to
    // /v3/external-callback/walley, so the thank-you page asks api4 for the status.
    const walleyResIdFromUrl = new URLSearchParams(search).get("r") ?? undefined;
    const paytrailStatus = new URLSearchParams(search).get("paytrail") ?? undefined;
    const paymentCallbackHash = paytrailStatus ? (new URLSearchParams(search).get("h") ?? undefined) : undefined;
    const [openLoginFromHeader, setOpenLoginFromHeader] = useState<boolean>(false);
    const validRedirectRefs = ["chauffeur", "launcher"] as const;
    useEffect(() => {
        const redirectRefParam = new URLSearchParams(search).get("redirectRef") ?? undefined;
        if (redirectRefParam && validRedirectRefs.includes(redirectRefParam as typeof validRedirectRefs[number])) {
            dataContext.changeRedirectRef(redirectRefParam as "chauffeur" | "launcher");
            const url = new URL(window.location.href);
            url.searchParams.delete('redirectRef');
            window.history.replaceState({}, '', url.toString());
        } else if (!dataContext.redirectRef && new URLSearchParams(search).get("utm_campaign") === 'launcher') {
            dataContext.changeRedirectRef('launcher');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // L13: first commit of the widget, for the startup timing report. The reporter the
    // module keeps delegates to the latest sendGa4Event, so the wrapper's defaults
    // (surface, vehicle_segment) come from the parameters the startup search used,
    // not from the render that armed it.
    useEffect(() => { markMount(); }, []);
    const sendGa4EventRef = useRef(dataContext.sendGa4Event);
    sendGa4EventRef.current = dataContext.sendGa4Event;
    // The shortcode's server-painted map placeholder (row L10) has done its job once
    // this tree has painted; its CSS hides it from then on, this frees the node.
    useEffect(() => retireServerMapPlaceholder(), []);
    // C2: on a landing that searches by itself, the host page's 3,320 px reservation is
    // released by the results page once that search completes. Login, booking and my
    // reservations never mount the results page, so they release it here — as the
    // sample results did at mount before C2.
    useEffect(() => {
        if (route === '/login' || route === '/makereservation' || route === '/myreservations') releaseHostReservation();
    }, [route]);
    const launcherMode = dataContext.redirectRef === 'launcher' ? '1' : undefined;
    const showLoginHeader = (!dataContext.loggedIn && !dataContext.reservationCreated &&
        (dataContext.page !== 2 && dataContext.page !== 3));
    const [isInView, setIsInView] = useState(false);
    const showOpenMapOneWay = !dataContext.oneWayRes || (dataContext.oneWayRes && !!sessionStorage.getItem('oneWaySearchInit'));
    // const { executeRecaptcha } = useGoogleReCaptcha(); // TODO: re-enable when BE reCaptcha is ready

    useEffect(() => {
        const rrmElement = document.getElementById('r24-App-Main');
        if (!rrmElement) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsInView(entry.isIntersecting);
            },
            { root: null, // observe within viewport
                threshold: 0.1, // 10% of the element is visible
            }
        );

        observer.observe(rrmElement);

        return () => {
            observer.unobserve(rrmElement);
        };
    }, []);

    useEffect(() => {
        if (import.meta.env.MODE === 'test') return;
        const prefetch = () => {
            import('./components/MakeReservation/MakeReservation').catch(() => {});
            import('./components/Login/LoginContainer').catch(() => {});
        };
        if (typeof requestIdleCallback === 'function') {
            const id = requestIdleCallback(prefetch);
            return () => cancelIdleCallback(id);
        }
        const id = setTimeout(prefetch, 2000);
        return () => clearTimeout(id);
    }, []);

    const checkForCancellation = () => {
        let createdRes: any = sessionStorage.getItem('rid-1') ?? undefined;
        let cancelledRes = new URL(window.location.href).searchParams.get('resCancelled') ?? undefined;
        const resetRRM = () => {
            let urlLang = new URLSearchParams(search).get("lang") ?? undefined;
            sessionStorage.setItem("route", "/");
            dataContext.clearSelections();
            dispatch({ type: "CLEAR_SELECTIONS", payload: null });
            window.location.href = window.location.href.split("?")[0] +
                (urlLang && urlLang === 'en' ? '?lang=en' : '');
        }

        if(!createdRes && cancelledRes) {
            resetRRM();
            return;
        }

        if (cancelledRes === 'true') {
            setShowPaymentResultScreen('cancelled');
            return;
        }

        if (cancelledRes && cancelledRes !== 'true') {resetRRM()}
    }

    // Back-nav-off-success guard. Distinguishes between:
    //   - reload of the `?r={id}` success URL → URL still has `?r=`,
    //     paymentSuccess='1' set → checkForWalleyCallback re-renders success ✓
    //   - browser back from success → URL no longer has `?r=`,
    //     paymentSuccess='1' set → reset RRM so the user can't end up on the
    //     payment screen and re-pay an already-paid reservation
    //
    // Reads the URL fresh (rather than the captured `walleyResIdFromUrl`) so
    // the popstate listener below can call this on URL change without a
    // re-render.
    const checkForBackNavFromSuccess = (): boolean => {
        if (!sessionStorage.getItem('paymentSuccess')) return false;
        const currentResId = new URLSearchParams(window.location.search).get('r');
        if (currentResId) return false; // still on a `?r=` URL — leave to checkForWalleyCallback
        const currentPaytrail = new URLSearchParams(window.location.search).get('paytrail');
        if (currentPaytrail) return false; // still on a `?paytrail=` URL — leave to checkForPaymentCallback

        claritySetSafe("walley_callback_reset_reason", "back_nav_after_success");
        clarityEventSafe("walley_callback_reset");
        const urlLang = new URLSearchParams(search).get("lang") ?? undefined;
        sessionStorage.setItem("route", "/");
        dataContext.clearSelections();
        dispatch({ type: "CLEAR_SELECTIONS", payload: null });
        window.location.href = window.location.href.split("?")[0] +
            (urlLang && urlLang === 'en' ? '?lang=en' : '');
        return true;
    };

    const checkForPaymentCallback = (): boolean => {
        if (!paytrailStatus) return false;

        const paymentPending = sessionStorage.getItem('paymentPending') ?? undefined;
        const createdResRaw = sessionStorage.getItem('rid-1') ?? undefined;

        const resetRRM = (reason: string) => {
            claritySetSafe("pcb_reset_reason", reason);
            clarityEventSafe("payment_callback_reset");
            const urlLang = new URLSearchParams(search).get("lang") ?? undefined;
            sessionStorage.setItem("route", "/");
            dataContext.clearSelections();
            dispatch({ type: "CLEAR_SELECTIONS", payload: null });
            window.location.href = window.location.href.split("?")[0] +
                (urlLang && urlLang === 'en' ? '?lang=en' : '');
        };

        if (sessionStorage.getItem('paymentSuccess') && paytrailStatus !== 'success') {
            resetRRM("paymentSuccess_stale_back_nav");
            return true;
        }

        if (!createdResRaw || !paymentPending) {
            resetRRM("no_in_flight_session");
            return true;
        }

        let createdRes: RidSessionData | undefined;
        try {
            createdRes = JSON.parse(createdResRaw);
        } catch {
            resetRRM("rid1_parse_failed");
            return true;
        }

        const createdResId = createdRes?.resId;

        let expectedHash: string;
        if (paytrailStatus === 'success') {
            const secret = window.__env?.PAYMENT_HASH_SECRET || '';
            expectedHash = encodeURI(md5((createdResId ?? '') + secret));
        } else {
            const secret = window.__env?.PAYMENT_HASH_SECRET_FAIL || '';
            expectedHash = encodeURI(md5((createdResId ?? '') + secret));
        }

        if (!paymentCallbackHash || paymentCallbackHash !== expectedHash) {
            resetRRM("hash_mismatch");
            return true;
        }

        claritySetSafe("pcb_result", paytrailStatus);
        clarityEventSafe("payment_callback_verified");

        const savedLang = createdRes?.lang;
        if (savedLang === 'en' && !new URLSearchParams(window.location.search).has('lang') && !window.location.pathname.includes('/en')) {
            const url = new URL(window.location.href);
            url.searchParams.set('lang', 'en');
            window.history.replaceState({}, '', url.toString());
        }

        if (new URL(window.location.href).searchParams.get('resCancelled') === 'true') {
            setShowPaymentResultScreen('cancelled');
            return true;
        }

        if (paytrailStatus === 'success') {
            setShowPaymentResultScreen('success');
            if (hasPendingPurchase(String(createdResId))) {
                dataContext.sendGa4Event("payment_attempt", {
                    payment_type: "paytrail",
                    payment_result: "success",
                });
                firePendingPurchase(String(createdResId), dataContext.sendGa4Event);
            }
        } else if (paytrailStatus === 'failure') {
            if (new URL(window.location.href).searchParams.get('retry') === 'true') {
                setShowPaymentResultScreen('retry');
            } else {
                setShowPaymentResultScreen('fail');
            }
            dataContext.sendGa4Event("payment_attempt", {
                payment_type: "paytrail",
                payment_result: "failure",
            });
        } else {
            resetRRM("unknown_paytrail_status");
            return true;
        }

        return true;
    };

    // Walley return-URL handler (`?r=`, no hash, no `paytrail=success/failure`).
    // It only routes the customer's redirect: the money-moved confirmation is the
    // server-to-server webhook Walley sends to BE at /v3/external-callback/walley,
    // and the confirming screen asks api4 for the result before saying thank you.
    const checkForWalleyCallback = (): boolean => {
        if (!walleyResIdFromUrl) return false;

        const paymentPending = sessionStorage.getItem('paymentPending') ?? undefined;
        const createdResRaw = sessionStorage.getItem('rid-1') ?? undefined;

        const resetRRM = (reason: string) => {
            claritySetSafe("walley_callback_reset_reason", reason);
            clarityEventSafe("walley_callback_reset");
            const urlLang = new URLSearchParams(search).get("lang") ?? undefined;
            sessionStorage.setItem("route", "/");
            dataContext.clearSelections();
            dispatch({ type: "CLEAR_SELECTIONS", payload: null });
            window.location.href = window.location.href.split("?")[0] +
                (urlLang && urlLang === 'en' ? '?lang=en' : '');
        };

        // No in-flight payment session and the URL has ?r=. Either a stale tab,
        // bookmarked link, or hand-crafted URL. Reset rather than fake a success
        // screen for a reservation we never created.
        if (!createdResRaw || !paymentPending) {
            resetRRM("no_in_flight_session");
            return true;
        }

        // Reload survival: if PaymentSuccess has already mounted in this session
        // (paymentSuccess='1') and we're seeing the same ?r= again, this is a
        // legitimate page reload, not a back-nav — show success again. (Walley
        // is idempotent here: BE's webhook is the source of truth for whether
        // the reservation is paid; rendering success is purely UI.)

        let createdRes: RidSessionData | undefined;
        try {
            createdRes = JSON.parse(createdResRaw);
        } catch {
            resetRRM("rid1_parse_failed");
            return true;
        }

        // ?r= must match the resId we created in this session. Mismatch = stale or
        // tampered URL. Note: BE has the truth via its webhook regardless of what
        // we render here — at worst this branch hides a legitimate success screen,
        // which is recoverable from "My Reservations".
        if (String(createdRes?.resId ?? '') !== String(walleyResIdFromUrl)) {
            resetRRM("resid_mismatch");
            return true;
        }

        // Walley's redirect URL may drop the lang param. Restore it from
        // rid-1 so the success screen loads in the same language the customer
        // used before payment.
        const savedLang = createdRes?.lang;
        if (savedLang === 'en' && !new URLSearchParams(window.location.search).has('lang') && !window.location.pathname.includes('/en')) {
            const url = new URL(window.location.href);
            url.searchParams.set('lang', 'en');
            window.history.replaceState({}, '', url.toString());
        }

        // Honor cancellation flow if a parallel `?resCancelled=true` is on the URL.
        // (Reservation cancellation is a separate flow from Walley payment.)
        if (new URL(window.location.href).searchParams.get('resCancelled') === 'true') {
            setShowPaymentResultScreen('cancelled');
            return true;
        }

        // Reload of the thank-you page of a booking paid without the Walley iframe
        // (invoice / quota / free / saved card): MakeReservation put `?r=` in the URL
        // and set paymentPending='paid' only after api4 confirmed the payment, and no
        // checkout token exists to ask with. Show success again.
        if (paymentPending === 'paid') {
            claritySetSafe("walley_callback_result", "success");
            clarityEventSafe("walley_callback_already_paid");
            setShowPaymentResultScreen('success');
            return true;
        }

        // The redirect back from Walley only means the customer finished the iframe.
        // The reservation is paid once the backend has captured the money, so ask
        // api4 first (card: seconds; invoice: may wait for Walley's approval). The
        // checkout token proves this browser started the payment; without it (old
        // tab, storage cleared) nothing can be checked, so the unconfirmed screen is
        // shown — never a success.
        const screen = walleyReturnScreen(walleyResIdFromUrl);
        claritySetSafe("walley_callback_result", screen === 'walley_confirming' ? "confirming" : "unconfirmed");
        clarityEventSafe(screen === 'walley_confirming' ? "walley_callback_confirming" : "walley_callback_unconfirmed");
        setShowPaymentResultScreen(screen);
        return true;
    };

    const hideWpContent = (id: string) => {
        let contentId = document.getElementById(id);
        if (contentId) {
            contentId.style.display = 'none'
        }
    }

    const showWpContent = (id: string) => {
        let contentId = document.getElementById(id);
        if (contentId) {
            contentId.style.display = 'block'
        }
    }

    useEffect(() => {
        const apiVersion = 'v3';
        dispatch({type: 'SET_API_VERSION', payload: apiVersion})
        dispatch({type: 'SET_API_URL', payload: v3ApiUrl})
        dispatch({type: 'SET_WALLEY_API_URL', payload: walleyApiUrl ?? ''})
        const apiService = ApiServiceFactory(
            token || "",
            jwt || "",
            apiVersion,
            v3ApiUrl,
            appContext ?? "",
            undefined,
            false,
            walleyApiUrl ?? "",
        );
        // Checking for production environment
        if(appContext !== "production") {
            console.log('Development environment ', apiVersion, v3ApiUrl);
        }
        dispatch({type: 'SET_API_SERVICE', payload: apiService});

        // check if url discount code is valid
        if (dataContext.reservationCreated || (!discount && !searchParameters?.discount)) return;

        if (discount && urlCodeSavedData) {
            // check if code was manually removed and do not reload it
            if (urlCodeSavedData === 'removed') return;
        }

        let codeToCheck = normalizeCouponCode(searchParameters?.discount ?? discount);
        if (codeToCheck === '') return; // if empty, return - no such URL exists
        apiService?.vehicle.getCoupon(codeToCheck)
            .then(r => {
                if (!r.valid) {
                    dataContext.changeStoredCoupon(null)
                    sessionStorage.removeItem("coupon");
                    sessionStorage.setItem('urlCodeValid', 'false')
                } else {
                    sessionStorage.setItem('urlCodeValid', 'true');
                    sessionStorage.setItem('coupon', JSON.stringify({ ...r, code: codeToCheck }));
                    dataContext.changeStoredCoupon({...r, code: codeToCheck});
                    dataContext.changeCouponDescription(r.description);
                    dataContext.changeCouponCode(codeToCheck);
                }}).catch(e => {
                console.log('coupon fail ' + e);
                dataContext.changeStoredCoupon(null);
                sessionStorage.setItem('urlCodeValid', 'false');
                sessionStorage.removeItem("coupon");
            })
    }, [token, jwt, dispatch, search]);

    useEffect(() => {
        if(dataContext.page === 0){
            dataContext.changeVehicle(null);
        }
    }, [dataContext.page]);

    const urlLogin = async () => {
        try{
            if(!customerId || !authHash){} // if no id or hash, do nothing
            // TODO: re-enable reCaptcha when BE is ready
            // let reCaptchaToken: string | undefined;
            // if (executeRecaptcha) {
            //     reCaptchaToken = await executeRecaptcha('login_hash');
            // }
            let data = JSON.stringify(
                {
                    "customerId": parseInt(customerId!),
                    "authenticationHash": authHash?.toString(),
                    // "reCaptchaToken": reCaptchaToken
                }
            );

            const res = await axios.post(`${v3ApiUrl}/login/try-authentication-hash`, data, {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                if(res.data?.data) {
                    const jwt: string = res.data?.data.jwt;
                    const token: string = res.data?.data.token.toString()
                    const loginData = res.data?.data;
                    const savedCardFields = {
                        savedCard: !!loginData.savedCard,
                        lastFourDigits: loginData.lastFourDigits || '',
                        cardType: loginData.cardType || '',
                        walleySavedCard: !!loginData.walleySavedCard,
                        walleyLastFourDigits: loginData.walleyLastFourDigits || '',
                        walleyCardType: loginData.walleyCardType || '',
                        savedCardB2B: !!loginData.walleySavedCardB2B,
                        lastFourDigitsB2B: loginData.walleyLastFourDigitsB2B || '',
                        cardTypeB2B: loginData.walleyCardTypeB2B || '',
                    };
                    if(token && jwt){
                        dispatch({type: 'SET_TOKEN', payload: {jwt, token}}); // token must be set before user is data is set
                        const customer = await axios.get(`${v3ApiUrl}/customers/me`,{
                            headers: {
                                Authorization: `Bearer ${jwt}`,
                                'X-Auth-Token': `${token}`
                            }
                        })
                        let useCompanyInfo = new URLSearchParams(search).get("useCompany") ?? undefined;
                        let phoneNumber = (customer.data.data.phoneNumber);
                        let birthdateValid = (customer.data.data.birthDate);
                        let countryValid = (customer.data.data.country !== null && customer.data.data.personalIdCodeRecorded);
                        if (birthdateValid && countryValid && phoneNumber && customer.data.data.givenName !== '' && customer.data.data.familyName !== '' &&
                            customer.data.data.address !== '' && customer.data.data.postalCode !== '' && customer.data.data.municipality !== '' &&
                            customer.data.data.phoneNumber !== '' && customer.data.data.email !== '' && isCompanyDataValid(customer.data.data.company)) {
                            dataContext.changeUser({...customer.data.data, ...savedCardFields, smsLogin: true, saveToCustomer: true});
                            if(authHash){
                                if (useCompanyInfo) {
                                    dataContext.changeUseCompanyInfo(useCompanyInfo === '1');
                                }
                                dataContext.changeLoggedIn(true, authHash);
                                dataContext.sendGa4Event("login", { login_method: "SMS", login_result: "success"});
                            }
                        } else {
                            if (phoneNumber) {
                                sessionStorage.setItem('AH-L', '1'); // will not allow number to be changed in customer info despite logged out view
                            }
                            dataContext.changeUser({...customer.data.data, ...savedCardFields, birthDate: birthdateValid ?? undefined, smsLogin: false, saveToCustomer: true});
                            if(authHash){
                                dataContext.changeLoggedIn(false, authHash)
                            }
                        }

                        if ((window as any).ap3c && customer.data.data.email){
                            // add customer when we know the email and if ap3c func exists
                            console.log('Ortto Tracking on');
                            (window as any).ap3c.track({"v":0 ,"email": customer.data.data.email});
                        }

                        if (launcherMode) {
                            dataContext.sendGa4Event("login", { login_method: "launcher_hash", login_result: "success"});
                        } else {
                            dataContext.sendGa4Event("login", { login_method: "hash", login_result: "success"});
                        }
                    }
                }
        } catch (e) {
            if (appContext !== "production") console.log(e);
            if (launcherMode) {
                dataContext.sendGa4Event("login", { login_method: "launcher_hash", login_result: "failure", login_error_code: "UNKNOWN" });
            } else {
                dataContext.sendGa4Event("login", { login_method: "hash", login_result: "failure",login_error_code: "UNKNOWN" });
            }
        }
    }
    // change jwt  data
    useEffect(() => {
        if(customerId && authHash){
            urlLogin()
        }
        if(dataContext.customer?.loggedIn && carId){
            if(carId === dataContext.vehicle?.id.toString()) {
                if(dataContext.vehicle.availabilityData?.available){
                    dataContext.changeRoute("/makereservation")
                } else{
                    if(appContext !== "production") {
                        console.log('vehicle not available')
                    }
                    dataContext.changePage(0)
                    dataContext.changeRoute("/")
                }
            }
        }

    }, [customerId, authHash, carId]);

    document.getElementsByClassName('mapboxgl-map')[0]?.setAttribute('style', 'height: 100vh')

    useEffect(() => {
        // 'en', or 'fi' for anything else (an incorrect url param or lang setting included)
        const apply = (language: 'fi' | 'en') => {
            dispatch({type: 'SET_LANG', payload: language})
            translateService.setLocale(language);
            dataContext.changeLanguage(language);
            if(lang) {
                // Merged into the current user, not this render's: English can arrive after a hash login
                dataContext.changeUserLanguage(language);
            }
        };
        if (lang !== 'en') { apply('fi'); return; }
        // English translations are not in the entry chunk (row I2): switch only once they are
        // registered, so no screen renders English keys; if they cannot be loaded, stay Finnish.
        const loading = ensureLanguage('en');
        if (!loading) { apply('en'); return; }
        let cancelled = false;
        loading.then(() => { if (!cancelled) apply('en'); }, () => { if (!cancelled) apply('fi'); });
        return () => { cancelled = true; };
    }, [dispatch, lang])

    useEffect(() => {
        changeRoute(sessionStorage.getItem("route"));
        if(mapEnableUrl === "true"){
            dataContext.changeMapEnable(true)
        } else if(mapEnableUrl === "false"){
            dataContext.changeMapEnable(false)
        }

        if (startDate && startDate.isSame(moment(), 'day') && !startDate.minute()) {
            startDate = moment().add(15, "minutes")
        }
        if (!startDate && !endDate && startOffset) {
            // only applies when neither absolute date is present — startdate/enddate always win
            const resolvedOffset = parseStartOffset(startOffset);
            if (resolvedOffset) {
                startDate = resolvedOffset;
            }
        }
        // junk and out-of-range `days` values are ignored rather than producing an invalid end date
        const lengthDays = parseLengthParam(day, MAX_URL_DAYS);
        // the link asked for specific dates — decided before the defaults below fill the gaps
        const hasUrlDates = !!startDate || !!endDate || lengthDays > 0;
        if (!startDate && !endDate) {
            startDate = searchParameters?.startDate ? moment(searchParameters?.startDate).clone() : defaultDate.clone()
            endDate = searchParameters?.endDate ? moment(searchParameters?.endDate).clone() : defaultDate.clone().add(2, "hours")
        } else if (!endDate && startDate && !lengthDays) {
            endDate = startDate.clone().add(2, "hours")
        } else if (!startDate && endDate && !lengthDays) {
            startDate = endDate.clone().subtract(2, "hours")
        }
        if (lengthDays && startDate) {
            endDate = startDate.clone().add(lengthDays, "days")
        } else if (lengthDays) {
            startDate = moment().add(2, "hours")
            endDate = moment().add(lengthDays, "days")
        }

        const defaultChangeSearchParameters = (altLat?: number, altLon?: number, altLocation?: any, altSearchCity?: string) => {
            if (altLocation) {
                // reset autocomplete value
                const input = document.getElementById('google-search-location') as HTMLInputElement | null;
                if (input) {
                    input.value = typeof altLocation === 'string' ? altLocation : altLocation[0];
                }
            }
            const startupLocation = !oneway ? altLocation ?? (((carId && !searchParameters?.location)
                || (modelId && (!city && !searchParameters?.location) ) ?
                    (latlng[2] === 0 ? "Helsinki" : latlng) // if default lat+lon in a2a mode --> "Helsinki" shows in search bar
                    : searchParameters?.location)) : null;
            // C2: a landing whose URL promised a startup search (DataProvider withheld the sample
            // results for it) but resolved without a location — geocoding failed, or the link
            // carried a code and the session had no place — shows the samples after all.
            // (One-way too: the samples do not render there, but the flag is what releases
            // the host page's reservation — an idle one-way form must not keep 3,320 px.
            // startupLocation only knows the URL's ?oneway=; a one-way mode restored from the
            // session gets a location here but searches by its cities, so it counts as well.)
            const oneWayStartup = oneway !== null || !!dataContext.oneWayRes;
            if ((!startupLocation || oneWayStartup) && !dataContext.showDefaultResults) {
                dataContext.changeShowDefaultResults(true);
            }

            changeSearchParameters({
                ...searchParameters,
                startDate:  startDate ?? searchParameters?.startDate,
                endDate: endDate ?? searchParameters?.endDate,
                startTime: (startDate?.clone().format("HH:mm")) ?? searchParameters?.startTime,
                endTime: (endDate?.clone().format("HH:mm")) ?? searchParameters?.endTime,
                discount: searchParameters?.discount ?? (discount! && urlCodeSavedData !== "removed" ? discount : undefined),
                lon: altLon ?? (searchParameters?.lon || latlng[1]),
                lat: altLat ?? (searchParameters?.lat || latlng[0]),
                carId: carId ? parseInt(carId) : null,
                distance: 30000,
                showStart: 0,
                km: 100,
                showAmount: 10,
                vehicleType: acriss ? acriss : searchParameters?.vehicleType,
                // Seed the car/van segment from the URL: explicit ?segment= wins; otherwise the
                // van body-type deep link (?acriss=5) implies van, other acriss codes imply car.
                vehicleSegment: (segmentParam === 'van' || segmentParam === 'car') ? segmentParam
                    : acriss === '5' ? 'van'
                    : acriss ? 'car'
                    : searchParameters?.vehicleSegment,
                location: startupLocation,
                userPlaceSearch: '', // reset from older for new url params search
                searchCity: altSearchCity, // resets like userPlaceSearch unless the url city geocode provided one
                // note: searchParameters.location can have 2 types: on startup + location to search  --> 'string', else 'object' (used in vehicle search component)
            })

            if (acriss) { // will not use acriss if user changed filter types or reset filter in session
                let filteredChanged = sessionStorage.getItem('filterChange') ?? undefined;
                if (filteredChanged === '1') {
                    return; // does not reoad apply if filter was changed by user before reload
                }
                changeAcrissCodeFromUrl(acriss);
            } else if (modelId) {
                changeModelId(modelId)

            }
        }

        const geocodeCity = () => {
            // Here is the documentation: https://developers.google.com/maps/documentation/javascript/geocoding#ReverseGeocoding
            const geocoder = new google.maps.Geocoder();
            geocoder.geocode({ address: city }, (results: any, status: string) => {
                markGeocodeDone();
                if (cancelled) return;
                if (status === 'OK') {
                    sessionStorage.setItem('locationFromUrl', '1'); // used to not auto open time & date picker popups after using url city for search
                    const { lat, lng } = results[0].geometry.location;
                    const geocodeLocation = results[0].address_components[0].long_name;
                    defaultChangeSearchParameters(lat(), lng(), geocodeLocation, extractCityFromPlace(results[0]));
                } else { // fallback to normal scenario without url city
                    if (dataContext.appContext !== 'production') {console.log('Geocode was not successful for the following reason: ' + status)};
                    defaultChangeSearchParameters();
                }
            });
        };

        let cancelled = false;
        const locationSource = resolveUrlLocation({
            city, discount, acriss, urlLat, urlLon, hasUrlDates,
            savedLocation: !!searchParameters?.location,
            savedDiscount: !!searchParameters?.discount,
            savedVehicleType: !!searchParameters?.vehicleType,
            oneWay: !!dataContext.oneWayRes || oneway !== null,
        });
        // L13: a landing that searches by itself is timed until its first results paint.
        armStartup(startupKindFor({
            locationSource,
            vehicleLink: !!(carId || modelId),
            oneWay: !!dataContext.oneWayRes || oneway !== null,
            savedLocation: !!searchParameters?.location,
            savedPickupCity: !!searchParameters?.pickupCity,
            savedReturnCity: !!searchParameters?.returnCity,
        }), (name, params) => sendGa4EventRef.current(name, params), {geocoded: locationSource === 'city'});
        if (locationSource === 'city') {
            void loadGoogleLibrary('geocoding').then(() => {
                markGeocodeLibrary();
                if (!cancelled) geocodeCity();
            }).catch(() => {
                // Leave the search usable; the customer can retry in the address field.
                if (!cancelled) defaultChangeSearchParameters();
            });
        } else if (locationSource === 'helsinki') {
            // TODO: confirm with BE — searchCity "Helsinki" is now also sent for code/acriss links, which
            // previously sent none; if the search narrows results by searchCity, pass it for date links only
            defaultChangeSearchParameters(latlng[0], latlng[1], "Helsinki", "Helsinki");
        } else if (locationSource === 'latlon') {
            defaultChangeSearchParameters(parseFloat(urlLat!), parseFloat(urlLon!), translateService.translate('vehicleSearch1.yourCurrentLocation'));
        }
        else {
            defaultChangeSearchParameters();
        }

        if (noVat) {
            // default setting to no vat if url param exists
            dataContext.changeNoVatPrices(true);
        }

        return () => {
            cancelled = true;
        };
    }, []);

    useEffect(() => {
        let apiVersion = 'v3';
        dispatch({type: 'SET_API_VERSION', payload: apiVersion})
        dispatch({type: 'SET_API_URL', payload: v3ApiUrl})
        dispatch({type: 'SET_WALLEY_API_URL', payload: walleyApiUrl ?? ''})
        const apiService = ApiServiceFactory(
            token || "",
            jwt || "",
            apiVersion,
            v3ApiUrl,
            appContext || "",
            undefined,
            false,
            walleyApiUrl ?? "",
        );
        dispatch({type: 'SET_API_SERVICE', payload: apiService})

    }, [token, jwt, dispatch, search]);

    useEffect(() => {
        // Mount-time: if user reloaded after back-navving off the success URL,
        // their fresh paint should reset rather than render the old payment screen.
        if (checkForBackNavFromSuccess()) return;
        // Paytrail callback runs first (?paytrail=success|failure&h=...).
        // If not a Paytrail callback, fall through to Walley (?r=...).
        if (checkForPaymentCallback()) return;
        checkForWalleyCallback();
    }, [])

    useEffect(() => {
        // In-SPA back-nav: browser popstate fires when the user clicks browser
        // back to a URL still inside this SPA (no hard reload). The mount-time
        // check doesn't catch this case because App.tsx is already mounted.
        const handlePopstate = () => { checkForBackNavFromSuccess(); };
        window.addEventListener('popstate', handlePopstate);
        return () => window.removeEventListener('popstate', handlePopstate);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (dataContext.resCancelled) {
            checkForCancellation();
        }
    }, [dataContext.resCancelled]);

    useEffect(() => {
        // will only active when moving between search and make reservation + if car id present in url on start
        if (route === '/makereservation' && dataContext.vehicle?.id) {
            // hide all other WordPress content if vehicle has been selected
            hideWpContent("wpcontent2");
            hideWpContent("wpcontent3");
            hideWpContent("wpcontent4");
            hideWpContent("wpcontent5");
            hideWpContent("wpcontent6");
            hideWpContent("wpcontent7");
            hideWpContent("wpcontent8");
            hideWpContent("wpcontent9");
        } else {
            // show all other WordPress content if search page
            showWpContent("wpcontent2");
            showWpContent("wpcontent3");
            showWpContent("wpcontent4");
            showWpContent("wpcontent5");
            showWpContent("wpcontent6");
            showWpContent("wpcontent7");
            showWpContent("wpcontent8");
            showWpContent("wpcontent9");
        }

        if(route === '/' && !searchParameters?.startDate && !searchParameters?.endDate) {
            // case: returning to search page after successful res - to ensure...
            // date pickers get set to correct next working day date
            let resetDateTimeValues = sessionStorage.getItem("resetDateTimes") ?? undefined;
            if(!resetDateTimeValues) return; // check so the following does not run on normal app startup

            const resetDates = nextWorkingDay().hour(8).minute(60); // avoid using 'defaultDates'...
            // from initial variables in cases where session kept open for too long
            sessionStorage.removeItem("resetDateTimes");
            changeSearchParameters({...searchParameters, startDate: resetDates.clone(),
                endDate: resetDates.clone().add(2, "hours")});
        }
    }, [route, dataContext.vehicle])

    // const button = document.querySelector('.menu-item-7453') ?? document.querySelector('.menu-item-30') // FI - EN urls respectively
    const loginDiv = document.querySelector('.r24_login');
    const mapBtn = document.getElementById('mapLoginBtn')
    if(mapBtn){
        mapBtn.addEventListener('click', (event) => {
            if (window.location.pathname === '/') {
                event.preventDefault();
            }
            setShowLogin(true);
        });
    }

    if (loginDiv) {
        loginDiv.addEventListener('click', (event) => {
            if (window.location.pathname === '/') {
                event.preventDefault();
            }

            if (dataContext.loggedIn === false && (!dataContext.customer?.givenName || dataContext.customer?.givenName === '')) {
                setShowLogin(true) // allow login if not already logged in & showing greeting header
            } else {
                setShowLogin(false)
            }
        });
    }

    useEffect(() => {
        // oneway url params
        if (enableOneWay) { // if enabled in app build
            if(oneway !== null) {
                // oneway param value can be anything, but if exists in url, oneway must be set true
                changeResType(true);}
        }
    }, [enableOneWay])

    useEffect(() => {
        changeRoute(sessionStorage.getItem("route"));
        changeCustomerBehaviourData(customerBehaviourData);
    }, []);

    // Lift the host page's loader overlay as soon as the widget is styled — not on window
    // load, which waits for everything else on the page too (see services/hostLoader.ts).
    useEffect(() => hideHostLoaderWhenReady(() => hideWpContent("wait")), []);

    useEffect(() => {
        // This useEffect specifically handles navigation on map since one-way searches do not contain search location coords
        // hence, if results exist --> use first results homeLocation data to set map canter for search
        if(dataContext.oneWayRes && dataContext.mapData && dataContext.mapData.length > 0) {
            let oneWayLat = dataContext.mapData[0].homeLocationData.coordinates.latitude;
            let oneWayLng = dataContext.mapData[0].homeLocationData.coordinates.longitude;
            if (oneWayLat && oneWayLng) {
                // adding slight offset to lat, lng to ensure green marker is not direct under a vehicle marker
                setLatlng([oneWayLat + 0.002, oneWayLng + 0.002, 1]);
            }
        } else {
            if (!dataContext.oneWayRes && latlng[2] === 1) {
                // setting lat, lng back to normal res coords + resTypeRef (0)
                setLatlng([60.167488, 24.942747, 0])}
        }
    }, [dataContext.oneWayRes, dataContext.mapData]);

    useEffect(() => {
        if(dataContext.oneWayRes && (searchParameters?.discount || storedCoupon)) {
            // clear all coupons when moving from one-way to normal reservation
            // no coupons can be used for one-way reservations
            dataContext.changeUser({ ...dataContext.user, couponCode: '' });
            dataContext.changeCouponCode('');
            dataContext.changeStoredCoupon(null);
            dataContext.changeCouponDescription('');
            dataContext.changeValidatedVipVehicles(-1);
            sessionStorage.removeItem("coupon");
            sessionStorage.setItem('urlCodeValid', 'removed');
            changeSearchParameters({...dataContext.searchParameters, discount: null});
        }
    }, [dataContext.oneWayRes])

    const SwitchComponents = () => {
        switch (route) {
            case "/":
                return <SearchResultsContainer setIsSearching={(v: string) => {
                }} setRedirect={(v: string) => {
                    if (v === "/login") {
                        setShowLogin(true);
                        changeRoute("/login")
                    } else {
                        changeRoute("/makereservation")
                    }
                }}/>
            case "/login":
                const LoginModal = () => {
                    return (
                        <Modal isOpen={!!(showLogin && API_URL)} onRequestClose={() => { setShowLogin(false); changeRoute('/'); }} style={cStylesApp} contentLabel='Login'>
                            <LoginContainer
                                setRedirect={(v: string) => { setShowLogin(false); changeRoute('/'); }}
                                customerInfoOpen={(dataContext.page === 2 && !dataContext.authHashLogin)}
                                setUser={dataContext.changeUser}
                                clearUserSelections={dataContext.clearSelections}
                                setIsLoggedIn={dataContext.changeLoggedIn}
                                sendGa4Event={sendGa4Event}
                                closeModal={() => { setShowLogin(false); changeRoute('/'); }}
                                appContext={dataContext.appContext ?? ''}
                                rootUrl={dataContext.rootUrl ?? ''}
                                loginFromHeader={true}
                            />
                        </Modal>
                    );
                }
                return <LoginModal />;

            case "/makereservation":
                return <MakeReservation
                    showPaymentResultScreen={showPaymentResultScreen}
                    setRedirect={(v: string) => {
                    if (v === "/login") {
                        setShowLogin(true);
                    }}}
                    setShowPaymentResultScreen={setShowPaymentResultScreen}/>
            case "/myreservations":
                return <MakeReservation
                    showPaymentResultScreen={showPaymentResultScreen}
                    setRedirect={() => {}}
                    setShowPaymentResultScreen={setShowPaymentResultScreen}/>
            default:
                return <SearchResultsContainer
                    setIsSearching={(v: string) => {
                }} setRedirect={(v: string) => {
                    if (v === "/login") {
                        setShowLogin(true);
                        changeRoute("/login")
                    } else {
                        changeRoute("/makereservation")
                    }
                }}/>
        }
    }

    const closeloginBtn = document.querySelector('.modal-close');
    if(closeloginBtn){
        closeloginBtn.addEventListener('click', () => {
            setShowLogin(false);
        });
    }

    useEffect(() => {
        SwitchComponents();

        // Stale-session cleanup: if the user is back on the search page with a
        // hydrated `reservationCreated` flag but no in-flight payment, wipe so
        // they don't re-enter a half-finished flow. (Phase 6 swapped the legacy
        // `paymentProviders` sentinel for `paymentPending` since the former is
        // gone now.)
        const paymentPending = sessionStorage.getItem('paymentPending') ?? undefined;
        if(route === "/" && (dataContext.reservationCreated && !paymentPending)) {
            dataContext.clearSelections();
            dispatch({ type: "CLEAR_SELECTIONS", payload: null });
        }
    }, [route, page, dataContext.reservationCreated]);

    const handleMapBtn = () => {
        if(dataContext.mobileDevice && !dataContext.mapCanInit) {
            // if mobile, allow map to initialize only when user opens map
            // only does this once
            dataContext.changeMapCanInit();
        }
        setShowFullScreenMap(true);
        // add scroll to top here
        let scrollAnchorEle = document.getElementById("r24-App-Main");
        if (scrollAnchorEle) {
            scrollToElementWithOffset(scrollAnchorEle, 50);
        }
        if(showFullScreenMap){
            setShowFullScreenMap(false)
        }
    }

    // The list-view sticky bar's map button asks to open the fullscreen map via this event
    // (the floating .mapBtn is render-gated, so we don't rely on clicking it).
    useEffect(() => {
        const openMap = () => {
            if (dataContext.mobileDevice && !dataContext.mapCanInit) { dataContext.changeMapCanInit(); }
            setShowFullScreenMap(true);
            const el = document.getElementById("r24-App-Main");
            if (el) { scrollToElementWithOffset(el, 50); }
        };
        window.addEventListener('rrm-open-map', openMap);
        return () => window.removeEventListener('rrm-open-map', openMap);
    }, [dataContext.mobileDevice, dataContext.mapCanInit]);

    // Measure fixed/sticky WP headers and expose as a CSS custom property for the
    // sticky bar overlay offset. Also lock page scroll so the WP page cannot scroll
    // behind the fixed fullscreen map (no-op on standalone where body doesn't scroll).
    useEffect(() => {
        if (!showFullScreenMap) return;
        const selectors = ['#wpadminbar', '#main-header', '.et-l--header', '.loginHeader', '.loginHeaderWP'];
        let total = 0;
        for (const sel of selectors) {
            const el = document.querySelector(sel);
            if (el) {
                const pos = getComputedStyle(el).position;
                if (pos === 'fixed' || pos === 'sticky') {
                    total += Math.round(el.getBoundingClientRect().height);
                }
            }
        }
        document.documentElement.style.setProperty('--rrm-header-offset', total + 'px');
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        return () => {
            document.documentElement.style.removeProperty('--rrm-header-offset');
            document.documentElement.style.overflow = '';
            document.body.style.overflow = '';
        };
    }, [showFullScreenMap]);

    useEffect(() => {
        if(route === '/'){
            dataContext.changePage(0)
        }
        // close map on mobile when only one vehicle is selected
        if(dataContext.mapData?.length === 1 && route === "/makereservation" && window.innerWidth <= 768){
            setShowFullScreenMap(false)
        }
    }, [dataContext.mapData, route]);

    return <div className={showLoginHeader ? 'r24WPContainerCustom' : ''} id={'r24-App-Main'}>
        {launcherMode ? null : // launcher mode should not show login or greeting
            showLoginHeader && !shortcodeLang ?
                <>
                    <div className='loginHeaderBackground'></div>
                    <div className='loginHeaderBackground loginHeader'>
                        <button  onClick={() => {setOpenLoginFromHeader(true); setShowLogin(true)}}
                                 className='btn-primary btn-outline-primary openLoginFromHeader'>
                            <img src={rootUrl + '/assets/icons/login-white.png'} alt='Login Icon' className='loginIcon' />
                        </button>
                    </div>
                </>
                : dataContext.loggedIn && dataContext.customer?.givenName && dataContext.customer?.givenName !== '' ?
                    <div className='greetingHeader'>
                        <button className='btn btn-primary btn-outline-primary greetingHeaderText' onClick={() => {}}>
                            {translateService.translate('rootContainer.greeting')}{dataContext.customer?.givenName?.split(' ')[0] || "" }
                        </button>
                    </div> : null }
        <div className={'flex-row mx-0 d-flex justify-content-between mainContainer'}>
            {/* One-way searches by city and never sets `location` (its map centres on fixed
                coords), so it is gated on a one-way search having run instead. */}
            {isInView && dataContext.mapEnabled && showOpenMapOneWay &&
            (dataContext.oneWayRes || dataContext.searchParameters?.location) &&
            !showPaymentResultScreen && !showFullScreenMap && !dataContext.vehicle ?
                // On mobile the sticky summary bar hides this button via data-rrm-summary-bar;
                // when the search form is expanded (bar hidden), this button reappears.
                // Hidden when the fullscreen map is open (the map's sticky bar has its own close button).
                <button className={`btn btn-secondary mapBtn`}
                    onClick={handleMapBtn}> { showFullScreenMap ? translateService.translate('briefingPhase.closeMapButton') :
                    translateService.translate('briefingPhase.openMapButton') } </button>
                : null}
            <div className={`px-0 overflow-auto justify-content-center pageContainer ${showFullScreenMap ? 'd-none' : 'mw-100'}`}>
                <ResponseModal
                    response={responseModal}
                    // tslint:disable-next-line: jsx-no-lambda
                    closeFunc={() => {dispatch({type: "SET_RESPONSE_MODAL", payload: undefined})}}/>
                <BusyModal message={apiMessage}/>
                <Modal isOpen={!!(showLogin && API_URL)} onRequestClose={() => setShowLogin(false)} style={cStylesApp} contentLabel='Login'>
                    <LoginContainer
                        setRedirect={(v: string) => {
                            setShowLogin(false)
                        }}
                        customerInfoOpen={(dataContext.page === 2 && !dataContext.authHashLogin)}
                        setUser={dataContext.changeUser}
                        clearUserSelections={dataContext.clearSelections}
                        setIsLoggedIn={dataContext.changeLoggedIn}
                        sendGa4Event={sendGa4Event}
                        closeModal={() => setShowLogin(false)}
                        appContext={dataContext.appContext ?? ''}
                        rootUrl={dataContext.rootUrl ?? ''}
                        loginFromHeader={openLoginFromHeader}
                        changeOpenLoginFromHeader={() => setOpenLoginFromHeader(false)}
                    />
                </Modal>
                {SwitchComponents()}
                <div className={'versionNumberDiv'}>
                    <p className={'versionNumber px-2'}>©{copyrightYear} 24Rental Network - v{version}</p>
                </div>
                <Dialog className='extension-modal' open={!!dataContext.twentyModal}>
                    <Card className={`card-body py-4`}>
                        <div className="text-center py-2">
                            <h5><Translate content={'vehicleSearch.twenty'} /></h5>
                        </div>
                        <button className={'btn btn-all mt-2 align-self-center'} style={{background: '#0BB395', width: '100px'}} onClick={() => {dataContext.changeTwentyModal(false)}}>
                            <span>OK</span>
                        </button>
                    </Card>
                </Dialog>
            </div>
            { dataContext.mapEnabled && !showPaymentResultScreen &&
                ((dataContext.oneWayRes && sessionStorage.getItem('oneWaySearchInit')) || !dataContext.oneWayRes) &&
                <div className={showFullScreenMap ? 'mapContainer mapContainerFullscreen' : 'mapContainer'}
                     onWheel={dataContext.showDefaultResults ? (e) => {
                         const page = document.querySelector('.pageContainer');
                         if (page) page.scrollTop += e.deltaY;
                     } : undefined}>
                    {showFullScreenMap && dataContext.filteredVehicles && !dataContext.oneWayRes && (
                        <div className={'mapFilterOverlay'}>
                            <SearchFilter openFilters={mapFiltersOpen} setCloseFilters={setMapFiltersOpen} />
                            {dataContext.mobileDevice ?
                                // Same sticky bar as the list view — the map's header. Edit closes the
                                // map and expands the form; the map button here closes the map.
                                <SearchSummaryBar
                                    overlay
                                    mapOpen
                                    location={dataContext.searchParameters?.location}
                                    pickupDate={dataContext.searchParameters?.pickupDate}
                                    returnDate={dataContext.searchParameters?.returnDate}
                                    onEdit={() => { setShowFullScreenMap(false); window.dispatchEvent(new Event('rrm-expand-search')); }}
                                    onMapToggle={() => setShowFullScreenMap(false)}
                                    showMapButton
                                    setOpenFilters={!dataContext.vehicle ? setMapFiltersOpen : undefined}
                                />
                                :
                                !dataContext.vehicle && <ActiveFilterIndicators setOpenFilters={setMapFiltersOpen} compact />
                            }
                        </div>
                    )}
                    {showFullScreenMap && dataContext.oneWayRes && !dataContext.vehicle && (
                        <div className={'mapFilterOverlay'}>
                            {/* Same spot and shape as .mapBtn ("Avaa kartta"), but not that class: .mapBtn
                                is hidden while the summary bar is active (index.scss). */}
                            <button type="button" className={'btn btn-secondary oneWayMapCloseBtn'}
                                    onClick={() => setShowFullScreenMap(false)}>
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                     strokeWidth="2.4" strokeLinecap="round" aria-hidden="true">
                                    <path d="M18 6 6 18M6 6l12 12"/>
                                </svg>
                                <span>{translateService.translate('briefingPhase.closeMapButton')}</span>
                            </button>
                        </div>
                    )}
                    <GoogleMap width={'100%'}
                               lat={!dataContext.oneWayRes ? dataContext.searchParameters?.lat || latlng[0] : latlng[0]}
                               lng={!dataContext.oneWayRes ?dataContext.searchParameters?.lon || latlng[1] : latlng[1]}/>
                </div>
            }
        </div>
    </div>
}

export default App
